import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {GlobalProvider} from "../../providers/global/global";

/**
 * Generated class for the ForgotPasswordPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {

  public forgotPassword: {email: string, confirmEmail: string} = {email: null, confirmEmail: null};

  constructor(public navCtrl: NavController, public navParams: NavParams,  private http: HttpClient, private globalProvider: GlobalProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPasswordPage');
  }

  public sendPasswordLink(forgotPassword: any): void {


    this.globalProvider.hasInternet()
      .then(()=>{
        this.http.post(this.globalProvider.apiURL+'/v1/reset_password', {email: forgotPassword.email})
          .finally(() => {
          })
          .subscribe((response: any) => {
              console.dir(response)
          }, (error) => {
            console.dir(error);
          })
      }, () => {
        console.log('keine internetverbindung -> login nicht möglich');
      });

    console.dir(forgotPassword);
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts